"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = require("react-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogWrapper = function DialogWrapper(_ref) {
  var children = _ref.children,
      isMobile = _ref.isMobile;
  return isMobile ? /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
    className: "react-google-flight-datepicker"
  }, children), document.querySelector('body')) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};

DialogWrapper.propTypes = {
  children: _propTypes.default.node,
  isMobile: _propTypes.default.string
};
DialogWrapper.defaultProps = {
  children: null,
  isMobile: false
};
var _default = DialogWrapper;
exports.default = _default;